import classNames from 'classnames/bind';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { HIGHER_CLASSES, LOWER_CLASSES } from 'constants/classes';
import DESTINATIONS from 'constants/destinations';
import LANGUAGES from 'constants/languages';
import Button from 'uikit/Button';
import InputTextArray from 'uikit/InputTextArray';
import CheckBox from 'uikit/CheckBox';
import Select from 'uikit/Select';
import InputText from 'uikit/InputText';
import Switch from 'uikit/Switch';

import styles from './SharePublic.module.scss';

const cx = classNames.bind(styles);

const SharePublic = ({ categories, handleSubmit, initialValues, t, tags }) => (
  <Formik initialValues={initialValues} onSubmit={handleSubmit}>
    {({ values }) => (
      <Form>
        <Switch
          className={cx('switch')}
          label={t(
            'Course/Teacher/Cover/CourseShare/SharePublic/make-course-public',
          )}
          name="isPublic"
        />
        <Select
          className={cx('property')}
          label={t(
            'Course/Teacher/Cover/CourseShare/SharePublic/select-category',
          )}
          name="category"
        >
          {categories.map((category) => (
            <option key={category.key} value={category.key}>
              {t(category.translation)}
            </option>
          ))}
        </Select>
        <Select
          className={cx('property')}
          label={t(
            'Course/Teacher/Cover/CourseShare/SharePublic/select-language',
          )}
          name="language"
        >
          {LANGUAGES.map((language) => (
            <option key={language.key} value={language.key}>
              {t(language.translation)}
            </option>
          ))}
        </Select>
        <InputText
          className={cx('property')}
          label={t('Course/Teacher/Cover/CourseShare/SharePublic/institution')}
          name="institution"
        />
        <Select
          className={cx('property')}
          label={t(
            'Course/Teacher/Cover/CourseShare/SharePublic/select-destination',
          )}
          name="destination"
        >
          {DESTINATIONS.map((destination) => (
            <option key={destination.key} value={destination.key}>
              {t(destination.translation)}
            </option>
          ))}
        </Select>
        {(values.destination === 'lower-education' ||
          values.destination === 'higher-education') && (
          <>
            <p className={cx('label')}>
              {t('Course/Teacher/Cover/CourseShare/SharePublic/select-classes')}
            </p>
            <div
              className={cx('classes', {
                higher: values.destination === 'higher-education',
              })}
            >
              {values.destination === 'lower-education' &&
                LOWER_CLASSES.map((lowerClass) => (
                  <CheckBox
                    key={lowerClass.key}
                    label={t(`${lowerClass.translation}`)}
                    name={`classes.${lowerClass.key}`}
                  />
                ))}
              {values.destination === 'higher-education' &&
                HIGHER_CLASSES.map((higherClass) => (
                  <CheckBox
                    key={higherClass.key}
                    label={t(`${higherClass.translation}`)}
                    name={`classes.${higherClass.key}`}
                  />
                ))}
            </div>
          </>
        )}
        <InputTextArray
          className={cx('property')}
          intent="square"
          label={t('Course/Teacher/Cover/CourseShare/SharePublic/add-tags')}
          name="tags"
          options={tags}
        />
        <Button intent="primary" type="submit">
          {t('Course/Teacher/Cover/CourseShare/SharePublic/save')}
        </Button>
      </Form>
    )}
  </Formik>
);

SharePublic.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SharePublic;
